// src/features/clean/cleanService.js
import api from "../../api/api";

/**
 * Ambil data client dari endpoint /cleans
 * @returns {Promise<Array>} - Array of clients dari API
 */
const getCleans = async () => {
  try {
    const response = await api.get("/cleans");
    // Laravel biasanya mengembalikan { data: [...] }
    return response.data.data || [];
  } catch (error) {
    console.error("Error fetching cleans:", error);
    return [];
  }
};

// Default export object
const cleanService = {
  getCleans,
};

export default cleanService;
